import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export default function CookiesPage() {
  const { t } = useLanguage();
  const rows = t("cookiesPage.rows") || [];

  const handleReset = () => {
    try {
      localStorage.removeItem("sxg-consent");
    } catch {}
    window.location.reload();
  };

  return (
    <main className="min-h-screen bg-[#0a0a0a] text-[#cbc1ad] py-16 sm:py-24 px-4 sm:px-6">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-[#d89557] hover:text-[#f4ede0] transition mb-10"
        >
          <ArrowLeft className="w-4 h-4" />
          {t("legal.backHome")}
        </Link>

        <span className="text-xs uppercase tracking-[0.32em] text-[#d89557]">
          {t("cookiesPage.label")}
        </span>
        <h1 className="font-display text-4xl sm:text-5xl text-[#f4ede0] mt-3 mb-4 leading-[1.1]">
          {t("cookiesPage.title")}
        </h1>
        <p className="text-xs text-[#7a716a] uppercase tracking-[0.22em] mb-10">
          {t("privacy.lastUpdate")}
        </p>

        <div className="text-sm leading-relaxed mb-10 whitespace-pre-line">
          {t("cookiesPage.intro")}
        </div>

        <div className="border border-[#2a2422] divide-y divide-[#2a2422] mb-10">
          {Array.isArray(rows) &&
            rows.map((r) => (
              <div key={`${r.cat}-${r.title}`} className="grid grid-cols-12 gap-4 p-4 sm:p-5">
                <div className="col-span-12 sm:col-span-3 text-xs uppercase tracking-[0.2em] text-[#d89557]">
                  {r.cat}
                </div>
                <div className="col-span-12 sm:col-span-9 text-sm text-[#cbc1ad]">
                  <div className="font-medium text-[#f4ede0] mb-1">{r.title}</div>
                  <div className="text-xs sm:text-sm leading-relaxed">{r.desc}</div>
                </div>
              </div>
            ))}
        </div>

        <div className="border border-[#b87333]/30 bg-[#b87333]/5 p-5 sm:p-6">
          <p className="text-sm text-[#cbc1ad] leading-relaxed mb-4">
            {t("cookiesPage.resetIntro")}
          </p>
          <button
            data-testid="reset-consent"
            onClick={handleReset}
            className="btn-copper px-6 py-3 text-xs uppercase tracking-[0.22em]"
          >
            {t("cookiesPage.resetButton")}
          </button>
        </div>
      </div>
    </main>
  );
}
